import {Box, Button, Input, Text, useToast, VStack} from "@chakra-ui/react";
import * as React from "react";
import {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/use-store";
import {changePage, setIsLeftToRight} from "../../../store/reducers";
import {getData} from "../../../utils/Utils";
import {verifyEmail} from "../../../data/api/Customer";
import {VerificationResponse} from "../../../data/model/VerificationResponse";

export const SignupPageFive = () => {
    const {producer, currentPage} = useAppSelector((state) => state.landing);
    const dispatch = useAppDispatch();
    const toast = useToast();

    const [code, setCode] = useState("");
    const [isVerifying, setIsVerifying] = useState(false);

    const handleVerify = async () => {
        if (!producer?.email) {
            toast({
                title: "Errore",
                description: "Email non disponibile. Torna indietro e riprova.",
                status: "error",
            });
            return;
        }

        setIsVerifying(true);

        try {
            const response = await verifyEmail(producer.email, code);

            const data = getData<VerificationResponse>(response);

            console.log({data});
            if (data?.message) {
                toast({
                    title: "Verifica completata",
                    description: "Email verificata con successo!",
                    status: "success",
                });
                dispatch(changePage((currentPage ?? 0) + 1));
            } else {
                toast({
                    title: "Codice non valido",
                    description: "Il codice inserito non è corretto o è scaduto.",
                    status: "error",
                });
            }
        } catch (e) {
            toast({
                title: "Errore di connessione",
                description: "Impossibile completare la verifica. Riprova più tardi.",
                status: "error",
            });
        } finally {
            setIsVerifying(false);
        }
    };

    return (
        <Box overflowY="auto">
            <Text
                color="primary.400"
                alignSelf="start"
                mt="24px"
                textAlign="center"
                fontSize={20}
            >
                Verifica la tua email
            </Text>

            <VStack mt="32px" spacing="16px" align="stretch">
                <Text color="gray.700" textAlign="center">
                    Inserisci il codice di verifica che hai ricevuto via email a{" "}
                    <strong>{producer?.email}</strong>
                </Text>

                <Input
                    placeholder="Inserisci il codice"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    size="lg"
                    textAlign="center"
                    fontSize="lg"
                />

                <Button
                    variant="primary"
                    isLoading={isVerifying}
                    onClick={handleVerify}
                    mt="16px"
                >
                    Verifica codice
                </Button>

                <Button
                    variant="tertiary"
                    mt="8px"
                    onClick={() => {
                        dispatch(setIsLeftToRight(true));
                        dispatch(changePage((currentPage ?? 0) - 1));
                    }}>
                    Indietro
                </Button>
            </VStack>
        </Box>
    );
};
